var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { ClickAwayListener, Popover as MuiPopover } from '@mui/material';
import Button from '../Button';
import React from 'react';
import colors from '../../themes/colors';
var ButtonWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var open = _a.open;
    if (!open) {
        return "\n      & svg {\n        fill: ".concat(colors.neutral90, ";\n\n        path {\n          fill: ").concat(colors.neutral90, ";\n        }\n      ");
    }
    return "\n    & svg {\n      fill: ".concat(colors.white, ";\n\n      path {\n        fill: ").concat(colors.white, ";\n      }\n    }\n  ");
});
var PopoverContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 16px;\n  min-width: 360px;\n"], ["\n  padding: 16px;\n  min-width: 360px;\n"])));
var DefaultElementWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var ButtonWithPopup = function (props) {
    var ref = React.useRef(null);
    var open = props.open, label = props.label, onClose = props.onClose, onOpen = props.onOpen, children = props.children, placement = props.placement, startIcon = props.startIcon, endIcon = props.endIcon, buttonElement = props.buttonElement;
    var overrideColors = {
        backgroundColor: (open ? colors.neutral80 : colors.neutral0),
        textColor: (open ? colors.white : colors.neutral100)
    };
    var _a = (placement !== null && placement !== void 0 ? placement : 'bottom-left').split('-'), v = _a[0], h = _a[1];
    var defaultElement = (_jsx(Button, { ref: ref, variant: "text", label: label, onClick: onOpen, endIcon: endIcon, startIcon: startIcon, overrideColors: overrideColors }));
    if (buttonElement) {
        defaultElement = (_jsx(DefaultElementWrapper, __assign({ onClick: onOpen, ref: ref }, { children: buttonElement })));
    }
    return (_jsxs(_Fragment, { children: [_jsx(ButtonWrapper, __assign({ open: open }, { children: defaultElement })), _jsx(MuiPopover, __assign({ slotProps: {
                    paper: { className: 'popover-celes' }
                }, transformOrigin: { vertical: -8, horizontal: 0 }, anchorOrigin: { horizontal: h, vertical: v }, anchorEl: ref.current, open: open }, { children: _jsx(ClickAwayListener, __assign({ onClickAway: onClose }, { children: _jsx(PopoverContainer, { children: children }) })) }))] }));
};
export default ButtonWithPopup;
var templateObject_1, templateObject_2, templateObject_3;
